import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { Controller } from "../../../../models/Controller";

interface SummaryProps {
    onBack: (e) => void;
    controllerToReplace: Controller;
}

const Summary: FC<SummaryProps> = ({ onBack, controllerToReplace }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <div className="pt-3 pr-3 h-full relative">
        <h2 className="text-lg font-bold">{translate.byKey(TranslationKeys.controllerToReplace)}</h2>

        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.name)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.fixedAddress)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.ipAddress)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{controllerToReplace.nameOriginal}</span>
                <span className="pt-1 text-sm text-black pl-2">{controllerToReplace.fixedAddress}</span>
                <span className="pt-1 text-sm text-black pl-2">{controllerToReplace.ipAddress}</span>
            </div>
        </div>

        <h2 className="text-lg font-bold pt-3">{translate.byKey(TranslationKeys.replaceWith)}</h2>

        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.name)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.fixedAddress)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.ipAddress)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.name}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.fixedAddress}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.ipAddress}</span>
            </div>
        </div>

        <div className="flex justify-end w-full absolute bottom-0 pr-3 pb-3 ">
            <button
                className={`py-1 px-5 mt-3 mr-2 text-portal-blue-primary-shade2`}
                type="button"
                onClick={(e) => onBack(e)}>{translate.byKey(TranslationKeys.back)}</button>
            <button
                className={`py-1 px-5 mt-3 bg-lime rounded-full text-white`}
                type="submit">
                {translate.byKey(TranslationKeys.replace)}</button>
        </div>
    </div>
}

export default Summary;
